"use strict";
var scrollable_directive_1 = require("./scrollable.directive");
exports.NguiScrollableDirective = scrollable_directive_1.NguiScrollableDirective;
var scrollable_module_1 = require("./scrollable.module");
exports.NguiScrollableModule = scrollable_module_1.NguiScrollableModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngui/scrollable/dist/index.js
// module id = 250
// module chunks = 4